// import isochrone from '@/pure/isochrone.public.json'
import axios from 'axios';
import config from '@/config';
import store from '../index';
import { reduceStudy } from './reducer';

const userId = 1;
const api = `${config.API_URL}/`;

class StudyApi {
  createStudy(data) {
    return axios({
      method: 'post',
      url: `${api}studies`,
      headers: {
        Authorization: `Token ${store.getters.apikey}`,
      },
      data: {
        user_id: userId,
        client_name: data.clientName,
        name: data.studyName,
      },
    });
  }
  patchStudy(data) {
    const { id, payload } = data;
    return axios({
      method: 'patch',
      url: `${api}studies/${id}`,
      headers: {
        Authorization: `Token ${store.getters.apikey}`,
      },
      data: payload,
    });
  }
  getIsochrone(data) {
    const { id, payload, isPrivate } = data;
    return axios({
      method: 'get',
      url: `${api}studies/${id}/isochrones?isPrivate=${isPrivate}`,
      headers: {
        Authorization: `Token ${store.getters.apikey}`,
        'Content-Type': 'application/octet-stream',
      },
      data: payload,
    }).then(result =>
      axios({
        method: 'get',
        url: result.data.url,
        headers: {
          'Content-Type': 'application/octet-stream',
        },
        data: {},
      }).then(response => response.data),
    );
  }
  checkCoverage(data) {
    const { addresses } = data;
    return axios({
      method: 'post',
      url: `${api}addresses/checkcoverage`,
      data: {
        addresses,
      },
      headers: {
        Authorization: `Token ${store.getters.apikey}`,
      },
    }).then(result => result.data);
  }
  uploadSiteImage(data) {
    return axios({
      method: 'patch',
      url: `${api}sites/picture`,
      headers: {
        Authorization: `Token ${store.getters.apikey}`,
      },
      data: data.file,
      onUploadProgress: data.onUploadProgress,
    });
  }
  getStudyRegions(data) {
    const { id } = data;
    return axios({
      method: 'get',
      url: `${api}studies/${id}/regions`,
      headers: {
        Authorization: `Token ${store.getters.apikey}`,
      },
    });
  }
  getStudyProductionDate(data) {
    const { id } = data;
    return axios({
      method: 'get',
      url: `${api}studies/${id}/productiondate`,
      headers: {
        Authorization: `Token ${store.getters.apikey}`,
      },
    }).then(result => result.data);
  }
  patchStudyRegions(data) {
    const { id, payload } = data;
    return axios({
      method: 'patch',
      url: `${api}studies/${id}/regions`,
      headers: {
        Authorization: `Token ${store.getters.apikey}`,
      },
      data: payload,
    });
  }
  importFile(data) {
    const { id, file, onUploadProgress } = data;
    let newData = new FormData();
    newData.append('file', file);
    return axios({
      method: 'post',
      url: `${api}studies/${id}/import`,
      headers: {
        Authorization: `Token ${store.getters.apikey}`,
      },
      data: newData,
      onUploadProgress: onUploadProgress,
    });
  }
  uploadLogo(data) {
    const { id, file } = data;

    let newData = new FormData();
    newData.append('file', file);

    return axios({
      method: 'put',
      url: `${api}studies/${id}/logo`,
      headers: {
        Authorization: `Token ${store.getters.apikey}`,
      },
      data: newData,
    });
  }
  downloadCsvFile(data) {
    const { id } = data;
    return axios({
      method: 'get',
      url: `${api}studies/${id}/csvfile`,
      headers: {
        Authorization: `Token ${store.getters.apikey}`,
      },
    });
  }
  postShareStudy(data) {
    const { id, share } = data;
    return axios({
      method: 'post',
      url: `${api}studies/${id}/share`,
      headers: {
        Authorization: `Token ${store.getters.apikey}`,
      },
      data: share,
    });
  }
  getShareStudy(data) {
    const { id } = data;
    return axios({
      method: 'get',
      url: `${api}studies/${id}/share`,
      headers: {
        Authorization: `Token ${store.getters.apikey}`,
      },
    });
  }
  resetUserAccount(data) {
    const { email, id } = data;
    return axios({
      method: 'put',
      url: `${api}studies/${id}/share/${encodeURIComponent(email)}`,
      headers: {
        Authorization: `Token ${store.getters.apikey}`,
      },
    });
  }
  deleteShareStudyUser(data) {
    const { id, email } = data;
    return axios({
      method: 'delete',
      url: `${api}studies/${id}/share/${email}`,
      headers: {
        Authorization: `Token ${store.getters.apikey}`,
      },
    });
  }
  getCurrentSites(data) {
    const { id } = data;
    return axios({
      method: 'get',
      headers: {
        Authorization: `Token ${store.getters.apikey}`,
      },
      url: `${api}studies/${id}/sites`,
    });
  }
  patchSites(data) {
    const { sites } = data;
    return axios({
      method: 'patch',
      url: `${api}sites`,
      headers: {
        Authorization: `Token ${store.getters.apikey}`,
      },
      data: {
        sites,
      },
    });
  }
  patchTargetSitesOrder(targetSites) {
    return axios({
      method: 'patch',
      url: `${api}sites/order`,
      headers: {
        Authorization: `Token ${store.getters.apikey}`,
      },
      data: {
        sites: targetSites,
      },
    });
  }
  deleteSite(id) {
    return axios({
      method: 'delete',
      url: `${api}sites/${id}`,
      headers: {
        Authorization: `Token ${store.getters.apikey}`,
      },
    });
  }
  postSites(data) {
    const { id, sites } = data;
    return axios({
      method: 'post',
      url: `${api}studies/${id}/sites`,
      headers: {
        Authorization: `Token ${store.getters.apikey}`,
      },
      data: {
        sites,
      },
    });
  }
  startProcessing(data) {
    const { id } = data;
    return axios({
      method: 'get',
      headers: {
        Authorization: `Token ${store.getters.apikey}`,
      },
      url: `${api}studies/${id}/startprocessing`,
    });
  }
  fetchProcessStatus(data) {
    const { id } = data;
    return axios({
      method: 'get',
      headers: {
        Authorization: `Token ${store.getters.apikey}`,
      },
      url: `${api}studies/${id}/status`,
    }).then(result => result.data);
  }
  geocode(data) {
    const { id } = data;
    return axios({
      method: 'get',
      headers: {
        Authorization: `Token ${store.getters.apikey}`,
      },
      url: `${api}studies/${id}/geocode`,
    }).then(result => result.data);
  }
  getStudyCsvFilters(data) {
    const { id } = data;
    return axios({
      method: 'get',
      headers: {
        Authorization: `Token ${store.getters.apikey}`,
      },
      url: `${api}studies/${id}/csvfilters`,
    }).then(result => result.data);
  }
  fetchCollaborators(data) {
    const { id } = data;
    return axios({
      method: 'get',
      headers: {
        Authorization: `Token ${store.getters.apikey}`,
      },
      url: `${api}studies/${id}/collaborators`,
    }).then(result => result.data);
  }
  putAddresses(data) {
    const { addresses } = data;
    return axios({
      method: 'put',
      headers: {
        Authorization: `Token ${store.getters.apikey}`,
      },
      url: `${api}addresses`,
      data: {
        addresses,
      },
    });
  }
  fetchStudies() {
    return axios({
      method: 'get',
      headers: {
        Authorization: `Token ${store.getters.apikey}`,
      },
      url: `${api}studies`,
    }).then(result =>
      result.data.map(item => ({
        id: item.public_id,
        name: item.name,
        created_at: item.created_at,
        clientName: item.client_name,
        user: item.user || {},
        needRefresh: item.need_refresh,
        countries: item.countries,
        draft_study_id: item.draft_study_id,
      })),
    );
  }
  getStudy(data) {
    const { id } = data;
    return axios({
      method: 'get',
      headers: {
        Authorization: `Token ${store.getters.apikey}`,
      },
      url: `${api}studies/${id}`,
    }).then(result => result.data);
  }
  deleteStudy(data) {
    const { id } = data;
    return axios({
      method: 'delete',
      headers: {
        Authorization: `Token ${store.getters.apikey}`,
      },
      url: `${api}studies/${id}`,
    }).then(result => result.data);
  }
  getStudyResult(data) {
    const { id } = data;
    return axios({
      method: 'get',
      headers: {
        Authorization: `Token ${store.getters.apikey}`,
      },
      url: `${api}studies/${id}/result`,
    })
      .then(result => result.data)
      .then(reduceStudy);
  }
  renewExpirationDate(id) {
    return axios({
      method: 'patch',
      url: `${api}studies/${id}/renewexpirationdateoneshot`,
      headers: {
        Authorization: `Token ${store.getters.apikey}`,
      },
    }).then(result => result.data);
  }
  updateExpirationDate(data) {
    const { id, expirationDate } = data;
    return axios({
      method: 'patch',
      url: `${api}studies/${id}/renewexpirationdate`,
      headers: {
        Authorization: `Token ${store.getters.apikey}`,
      },
      data: {
        expiration_date: expirationDate,
      },
    }).then(result => result.data);
  }
  updateStudyName(data) {
    const { id, name } = data;
    return axios({
      method: 'patch',
      url: `${api}studies/${id}/name`,
      headers: {
        Authorization: `Token ${store.getters.apikey}`,
      },
      data: {
        new_study_name: name,
      },
    }).then(result => result.data);
  }
  updateMaximumTravelTime(studyId, data) {
    return axios({
      method: 'patch',
      url: `${api}studies/${studyId}/maximumtraveltime`,
      headers: {
        Authorization: `Token ${store.getters.apikey}`,
      },
      data,
    }).then(result => result.data);
  }
  uploadRawData(data) {
    const { id, content } = data;
    return axios({
      method: 'post',
      url: `${api}studies/${id}/rawdata`,
      headers: {
        Authorization: `Token ${store.getters.apikey}`,
      },
      data: {
        content: JSON.stringify(content),
      },
    }).then(result => result.data);
  }
  downloadRawData(data) {
    return axios({
      method: 'get',
      url: data,
    }).then(response => response.data);
  }
  getStudyDraftId(data) {
    const { originalStudyId } = data;
    return axios({
      method: 'get',
      url: `${api}studies/copy/${originalStudyId}`,
      headers: {
        Authorization: `Token ${store.getters.apikey}`,
      },
    }).then(response => response.data.public_id);
  }
  exportStudyCsv(studyId) {
    return axios({
      method: 'get',
      url: `${api}studies/${studyId}/csvfile`,
      headers: {
        Authorization: `Token ${store.getters.apikey}`,
      },
    }).then(response => response.data);
  }

  exportCollabCsv(studyId) {
    return axios({
      method: 'get',
      url: `${api}studies/${studyId}/export/collaborators?culture=${store.getters.userLanguage}`,
      headers: {
        Authorization: `Token ${store.getters.apikey}`,
      },
    }).then(response => response.data);
  }

  createStudyDuplicate(data) {
    return axios({
      method: 'get',
      url: `${api}studies/copy/${data.studyId}`,
      params: {
        newStudyName: `${data.studyName}_copy`,
      },
      headers: {
        Authorization: `Token ${store.getters.apikey}`,
      },
    })
      .then(response => response.data)
      .catch(error => {
        throw error.response;
      });
  }
}

export default StudyApi;
